// extracted by mini-css-extract-plugin
module.exports = {"postMessage":"styles_postMessage__1RROU"};